export default __webpack_public_path__ + "static/media/before_work_sample.eb4164b7.png";